var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWinnersBottomWaveDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1440 83"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#031E29",
  d: "M1065.65 27.487C1244.61 27.487 1440 83 1440 83V0H0v12.27S115.233 55.5 262 39.644c199-21.5 239.796 17.48 397.814 22.137 158.019 4.658 226.873-34.294 405.836-34.294"
})));
export default SvgWinnersBottomWaveDesktop;